// src/utils/inventoryUtils.ts
import { InventoryStatus } from "../models/cart/types";

const normalizeStatus = (
  s: string | number | undefined
): InventoryStatus | undefined => {
  if (s === undefined || s === null) return undefined;
  if (typeof s === "string") {
    return InventoryStatus[s as keyof typeof InventoryStatus];
  }
  return s;
};

export const statusLabel = (s?: InventoryStatus): string => {
  const status = normalizeStatus(s);
  switch (status) {
    case InventoryStatus.Stocked:
      return "Stocked";
    case InventoryStatus.Available:
      return "Available";
    case InventoryStatus.InNetwork:
      return "Stocked in Network";
    case InventoryStatus.SpecialItem:
      return "Special Order";
    case InventoryStatus.ContactBranchForAvailability:
      return "Contact Branch for Pricing";
    case InventoryStatus.OutOfStock:
      return "Out Of Stock";
    default:
      return "";
  }
};

export const statusColor = (s?: InventoryStatus): string => {
  const status = normalizeStatus(s);
  switch (status) {
    case InventoryStatus.Stocked:
    case InventoryStatus.Available:
    case InventoryStatus.InNetwork:
      return "#008000";
    case InventoryStatus.SpecialItem:
      return "#ff0000";
    case InventoryStatus.ContactBranchForAvailability:
      return "#000000";
    case InventoryStatus.OutOfStock:
      return "#af272f";
    default:
      return "#000000";
  }
};
